<template>
    <div class="addFileProgress">
        <span class="addFileProgressName">
            {{ this.initialValue.value[this.index].name }}
        </span>
        <span class="correctUpload"></span>
        <button @click="delFile" class="addFileProgressDelete">
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <g fill="#000" fill-rule="nonzero" stroke="#F8F8F8">
                        <path d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1zm0 20.281A9.276 9.276 0 0 1 2.719 12 9.276 9.276 0 0 1 12 2.719 9.276 9.276 0 0 1 21.281 12 9.276 9.276 0 0 1 12 21.281z"/>
                        <path d="M15.866 14.618 13.25 12l2.617-2.618a.883.883 0 0 0-1.248-1.248L12 10.75 9.382 8.134a.883.883 0 1 0-1.248 1.248L10.75 12l-2.617 2.618a.883.883 0 1 0 1.248 1.248L12 13.25l2.618 2.617a.883.883 0 1 0 1.248-1.248z"/>
                    </g>
                </svg>
        </button>
        <div class="progressBar">
            <div class="progress"></div>
        </div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,

    props: {
        name:{
            type: String,
            required:false
        },
        index:{
            type: Number,
            required: false
        },
        initialValue: {
            required: false,
            default: ""
        },
        initialErrors: {
            type: Array,
            required: false,
            default: () => []
        },
    },
    methods: {
        delFile: function(){
            const name = this.name;
            const index = this.index;
            return this.$emit("click", name, index);
        }
    },
};

</script>

<style lang="scss" scoped>
.addFileProgress{
    // height: 50px;
    margin: 12px 0 0 1px;
    padding: 15px 20px 21px 2px;
    display: block;
    color: #000000;

    &>.addFileProgressName{
        margin: 0 0 0 25px;
    }

    &>.addFileProgressDelete{
        width: 16px;
        height: 16px;
        margin: -22px 0px 0px auto;
        display: block;
    }

    &>.correctUpload{
        color: #4ba600;
        margin: -25px 0px 0px auto;
        display: block;
        animation: showCheckUpload 4s linear;

        &:after{
            content: "\2713";
            font-weight: bold;
            font-size: 18px;
        }
    }

    &>.progressBar{
        height: 4px;
        margin: 20px 0px 0px 15px;
        border-radius: 2px;
        background-color: #d8d8d8;

        &>.progress{
            height: 4px;
            background-color:#4ba600 ;
            border-radius: 2px;
            animation: progress 4s ease;
        }
    }

    &:hover{
        background-color: #dfeaf2;
        border-color: #00559a;
        color: #000000;
    }

    @keyframes progress {
        0% {
            width: 1px;
            background-color: #00559a;
        }
        98%{
            background-color: #00559a;
        }
        100% {
            width: 100%;
            background-color: #4ba600;
        }
    }

    @keyframes showCheckUpload {
        0% {
            opacity: 0;
		    transform: scale(0);
        }
        99%{
            opacity: 0;
		    transform: scale(0);
        }
        100% {
            opacity: 1;
		    transform: scale(1);
        }
    }
}
</style>
